import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload} from "@fortawesome/free-solid-svg-icons";
import CustomerConsignmentStatusType from "../common/enum/CustomerConsignmentStatusType";
import API from "../../services/API";

interface ConsignmentProofOfDeliveryButtonProps {
    consignment: CustomerAPIConsignmentResponse
}

const ConsignmentProofOfDeliveryButton = ({
    consignment
}: ConsignmentProofOfDeliveryButtonProps) => {

    const openWindow = (e: React.MouseEvent) => {
        e.stopPropagation();
        window.open(`${API.ORIGIN}/customer/v1/consignments/${consignment.id}/documents/proof-of-delivery`);
    };

    const status = CustomerConsignmentStatusType.valueOf(consignment.status);
    if (status !== CustomerConsignmentStatusType.COMPLETED) {
        return null;
    }
    return (
        <button
            className="btn btn-outline-primary"
            onClick={openWindow}
        >Proof of Delivery <FontAwesomeIcon icon={faDownload}/>
        </button>
    )

}

export default ConsignmentProofOfDeliveryButton;
